import React, { useEffect } from 'react';

// Utils
import micromodal from 'micromodal';
import { isNil } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useAppContext } from '../../../store/AppContext';
import useScroll from '../../../utils/hooks/useScroll';
import cn from '../../../utils/tools/cn';

// Icons
import { ReactComponent as CloseIcon } from '../../../assets/icons/cross.svg';

// Components
import Button from '../../atoms/Button/Button';

import styles from './Modal.module.scss';

function Modal() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [{ modal, modalQueryLoading }] = useAppContext();

  const { lockBodyScroll } = useScroll();

  useEffect(() => {
    lockBodyScroll(!isNil(modal));
  }, [modal]);

  const closeModal = () => {
    if (modal.id) micromodal.close(modal.id);
  };

  return modal ? (
    <div className="modal micromodal-slide" id={modal.id} aria-hidden="true">
      <div className="modal__wrapper">
        <div role="presentation" className="modal__overlay" onClick={closeModal} />
        <div
          className={cn(['modal__container', modal.fullHeight ? 'full-height' : ''])}
          role="dialog"
          aria-modal="true"
          aria-labelledby={`${modal.id}-title`}
          style={{ maxWidth: modal.maxWidth && !isMobile ? modal.maxWidth : '' }}
        >
          <div className={cn(['modal__inner-container', modal.buttons?.length ? '' : 'no_buttons'])}>
            <div className={cn(['d-flex a-stretch', !modal.coverImage ? 'd-col' : 'mobile-d-col-reverse'])}>
              {modal.coverImage ? (
                <div
                  className={cn([
                    styles.cover_image,
                    'm-r-20 mobile-m-r-0 mobile-m-b-0 mobile-m-t-30',
                  ])}
                >
                  {modal.coverImage}
                </div>
              ) : null}

              <div className="d-flex d-col a-stretch flex-auto">
                <header className={cn(['modal__header', modal.coverImage ? 'm-t-10' : ''])}>
                  {modal.title ? (
                    <h2
                      id={`${modal.id}-title`}
                      className="modal__title fs-24"
                    >
                      {modal.title}
                    </h2>
                  ) : null}

                  <button
                    type="button"
                    className="modal__close"
                    aria-label="Close"
                    onClick={() => closeModal()}
                  >
                    <CloseIcon width={20} height={20} />
                  </button>
                </header>

                <main className={cn(['modal__content d-flex d-col a-stretch'])} id={`${modal.id}-title`}>
                  <div className="m-b-auto">{modal.content}</div>

                  {modal.buttons?.length ? (
                    <div className={cn([styles.buttons, 'd-flex f-wrap a-center j-end m-t-20'])}>
                      {modal.buttons.map(({
                        label, onClick, theme, queryName, disabled,
                      }, index) => (
                        <div key={index}>
                          <Button
                            onClick={onClick || closeModal}
                            theme={theme}
                            full={isMobile}
                            isLoading={modalQueryLoading === queryName}
                            disabled={!isNil(modalQueryLoading) || disabled}
                          >
                            {label}
                          </Button>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default Modal;
